var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-cont"},[(_vm.status == 'loading')?_c('div',{staticClass:"more"},[_c('a-spin')],1):_vm._e(),(_vm.status == 'noMore')?_c('div',{staticClass:"more"},[_c('span',{staticClass:"no-cont"},[_vm._v("没有更多数据")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }